export function getPreferredLanguage() {
  return localStorage.getItem("preferredLang") || "en";
}

export function applyPreferredLanguage(lang) {
  const safeLang = lang === "es" ? "es" : "en";
  const cookieValue = safeLang === "es" ? "/en/es" : "/en/en";

  document.cookie = `googtrans=${cookieValue};path=/;max-age=31536000`;
  localStorage.setItem("preferredLang", safeLang);

  const overlay = document.getElementById("lang-overlay");
  if (overlay) {
    overlay.style.display = "flex";
  }

  setTimeout(() => {
    window.location.reload();
  }, 250);
}
